export default __webpack_public_path__ + "static/media/bordershape.52c7c625.svg";